/** Waits for browser paint boundaries and stops early when cancelled. */
export async function waitForBrowserPaint(
  signal?: AbortSignal,
  frames = 1,
): Promise<boolean> {
  for (let index = 0; index < frames; index += 1) {
    if (signal?.aborted) return false;
    const painted = await new Promise<boolean>((resolve) => {
      let settled = false;
      let frameId = 0;
      const finish = (value: boolean) => {
        if (settled) return;
        settled = true;
        clearTimeout(timeoutId);
        signal?.removeEventListener("abort", onAbort);
        if (!value && typeof cancelAnimationFrame === "function") {
          cancelAnimationFrame(frameId);
        }
        resolve(value);
      };
      const onAbort = () => finish(false);
      const timeoutId = window.setTimeout(() => finish(false), 250);
      signal?.addEventListener("abort", onAbort, { once: true });
      frameId = requestAnimationFrame(() => finish(true));
    });
    if (!painted) return false;
  }
  return !signal?.aborted;
}
